import { FormattedMessage } from 'react-intl';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { DEFAULT_VALUES } from '@/libraries/web-framework/src/localization/values';
const UnlimitedWhiteboards = () => {
	const localizedHref = useLocalizedHref('/software/confluence/whiteboards');
	return (
		<div>
			<p>
				<FormattedMessage
					id="ConfluencePricingPageTeam24.features.unlimitedWhiteboards.content.body"
					defaultMessage="Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. With Premium, unlock unlimited whiteboards and advanced Jira integrations to brainstorm, plan and action work like never before. <a>Learn more.</a>"
					values={{
						...DEFAULT_VALUES,
						a: (chunks) => (
							<a
								data-event="clicked"
								data-event-component="linkButton"
								data-product-key="confluence"
								data-track-event="ConfluencePricingPageTeam24.unlimitedWhiteboards.learnMore"
								data-event-container="ConfluencePriceFinderTeam24"
								data-label-english="learn more"
								href={localizedHref}
							>
								{chunks}
							</a>
						),
					}}
				/>
			</p>
		</div>
	);
};
export default UnlimitedWhiteboards;
